import type React from 'react';
import { type CloseButtonProps } from 'react-toastify';

const CustomCloseButton: React.FC<CloseButtonProps> = ({ closeToast }) => (
  <button
    onClick={(e) => closeToast(e)}
    className="text-[#212121] hover:text-[#424242] absolute top-1 right-2"
  >
    ✕
  </button>
);

export default CustomCloseButton;
